"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SubModule_1 = require("../../SubModule");

var CountRestrictions_1 = require("./CountRestrictions");

var PercentageRestrictions_1 = require("./PercentageRestrictions");
/**
 * Namespace that handles all Transfer Restriction related functionality
 */


var Restrictions =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Restrictions, _SubModule_1$SubModul);

  /**
   * Create a new Restrictions instance
   */
  function Restrictions(securityToken, context) {
    var _this;

    _classCallCheck(this, Restrictions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Restrictions).call(this, securityToken, context));
    _this.count = new CountRestrictions_1.CountRestrictions(securityToken, context);
    _this.percentage = new PercentageRestrictions_1.PercentageRestrictions(securityToken, context);
    return _this;
  }

  return Restrictions;
}(SubModule_1.SubModule);

exports.Restrictions = Restrictions;